import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReferenceDialogComponent } from '../../_modules/shared/_components/reference-dialog/reference-dialog.component';
import { SnackbarComponent } from '../../_modules/shared/_components/snackbar/snackbar.component';

@Injectable({
    providedIn: 'root',
})
export class SnackbarService {
    constructor(
        private snackBar: MatSnackBar,
        private matDialog: MatDialog
    ) {}

    successSnackbar(message: string, referenceNumber?: string) {
        console.log(message);
        console.log(referenceNumber);
        if (referenceNumber) {
            this.matDialog.open(ReferenceDialogComponent, {
                data: {
                    message: 'copyReferenceNumberForYourRecords',
                    referenceNumber: referenceNumber,
                    title: 'referenceNumber',
                    cancelButtonLabel: 'close',
                },
            });
        }

        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'end',
            verticalPosition: 'top',
            duration: 7000,
            data: {
                message,
                type: 'success',
                ...(referenceNumber
                    ? {
                          showHelperBlock: true,
                          helperNumber: referenceNumber,
                          helperHeading: 'referenceNumber',
                      }
                    : { showHelperBlock: false }),
            },
            panelClass: 'snackbar-custom',
        });
    }

    errorSnackbar(message: string, traceId?: string) {
        console.log(message);
        console.log(traceId);

        if (traceId) {
            this.matDialog.open(ReferenceDialogComponent, {
                data: {
                    message: 'copyTraceIdForYourRecords',
                    referenceNumber: traceId,
                    title: 'error',
                    cancelButtonLabel: 'close',
                },
            });
        }

        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'end',
            verticalPosition: 'top',
            duration: 7000,
            data: {
                message,
                type: 'error',
                ...(traceId
                    ? {
                          showHelperBlock: true,
                          helperNumber: traceId,
                          helperHeading: 'traceId',
                      }
                    : { showHelperBlock: false }),
            },
            panelClass: 'snackbar-custom',
        });
    }

    warningSnackbar(message: string, traceId?: string, duration = 7000) {
        console.log(message);
        console.log(traceId);

        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'end',
            verticalPosition: 'top',
            duration,
            data: {
                message,
                type: 'warning',
                ...(traceId
                    ? {
                          showHelperBlock: true,
                          helperNumber: traceId,
                          helperHeading: 'traceId',
                      }
                    : { showHelperBlock: false }),
            },
            panelClass: 'snackbar-custom',
        });
    }
}
